import { useCan } from "@refinedev/core";
import { useMe } from "@src/hooks/use-me";
import { ExplorationType } from "@src/pages/ab-test-explore/enum/exploration-types.enum";
import { Tooltip, Typography } from "antd";
import { Link } from "react-router-dom";

export const TitleColumn: React.FC<{ value?: string; record: any }> = ({ value, record }) => {
    const { isSuperAdmin } = useMe();
    const productCode = record.product_code;
    const { data: dataCanEdit } = useCan({
        resource: "exploration",
        action: "edit",
        params: {
            productCode: productCode,
        },
    });
    const canEdit = dataCanEdit?.can;
    let link =
        isSuperAdmin || canEdit
            ? `/explorations/firebase/edit/${record?.id}`
            : `/explorations/firebase/show/${record?.id}`;
    if (record?.type === ExplorationType.AB_TEST) {
        link = `/explorations/ab-test/${record.id}`;
    }
    if (record?.type === ExplorationType.INTELLIGENCE_SEARCH) {
        link = `/explorations/intelligence-search/${record.id}`;
    }
    if (record?.type === ExplorationType.INTELLIGENCE_SEARCH_V2) {
        link = `/explorations/intelligence-searches/${record.id}`;
    }
    return (
        <Tooltip destroyOnHidden title={value} className="w-[200px]" placement="topLeft">
            <Typography.Paragraph
                onClick={(e) => e.stopPropagation()}
                ellipsis={{
                    rows: 2,
                    expandable: false,
                }}
            >
                <Link to={link}>{value || "-"}</Link>
            </Typography.Paragraph>
        </Tooltip>
    );
};
